import { Subscription } from 'rxjs';
import { BlogUserModel } from './../../core/model/object/blog-user-model';
import { Component, HostListener, OnDestroy, OnInit } from '@angular/core';
import { SettingService } from 'src/app/data/repository/setting-repository/setting.service';
import { MatDialog } from '@angular/material/dialog';
import { LogoutComponent } from './logout/logout.component';
import { SettingsAnalyticsService } from 'src/app/data/repository/analytics-repository/settings-analytics.service';
import { User } from 'src/app/core/model/user-model';
import { BlogApiService } from 'src/app/data/repository/blog-repository/blog-api.service';

@Component({
  selector: 'app-setting',
  templateUrl: './setting.component.html',
  styleUrls: ['./setting.component.scss'],
})
export class SettingComponent implements OnInit, OnDestroy {
  settingTitles = ['اطلاعات شخصی', 'تریبون', 'پشتیبانی', 'خروج از حساب کاربری'];
  selectedType: string;
  showEdit: boolean = false;
  user: User;
  blogUser: BlogUserModel;
  Subscriptions: Subscription[] = [];
  constructor(
    private settingService: SettingService,
    public dialog: MatDialog,
    private settingAnalytics: SettingsAnalyticsService,
    private BlogApiService: BlogApiService
  ) {
    const open = this.settingService.bottomSheet.subscribe((data) => {
      if (data) {
        this.showEdit = data.show;
        this.selectedType = data.data.selected;
        if (data.data.user) {
          this.user = data.data.user;
        }
        console.log(data);

        if (data.data.blogUser) {
          this.blogUser = data.data.blogUser;
        }
      }
    });
    const closebs = this.settingService.closeBottomSheet.subscribe((close) => {
      if (close) {
        this.showEdit = false;
      }
    });

    this.Subscriptions.push(closebs, open);
  }

  ngOnInit() {
    this.settingAnalytics.analyticSettingVisited();
  }

  back() {
    this.settingService.goBack();
  }

  @HostListener('window:beforeunload')
  ngOnDestroy(): void {
    this.Subscriptions.forEach((sb) => sb.unsubscribe());
  }
  settingSelected(page: string) {
    // settingSelected(index: number) {
    // if (index === 0) {
    //   this.settingService.goToPersonalInformation();
    // } else if (index === 1) {
    //   this.settingService.goToBlogInformation();
    // } else if (index === 2) {
    //   this.settingService.goToSupportPage();
    // } else if (index === 3) {
    //   const dialogRef = this.dialog.open(LogoutComponent, { width: '90%', panelClass: 'custom-dialog-container' });
    // }
    if (page === 'support') {
      this.settingService.goToSupportPage();
    } else if (page === 'logout') {
      const dialogRef = this.dialog.open(LogoutComponent, {
        width: '90%',
        panelClass: 'custom-dialog-container',
      });
    }
  }
}
